import { ADS_FUNNEL_UNSAFE_KEYS, } from './ads-builder.js';
/** Ключи значения с условиями, чей массив — значение-список (множество), а не последовательность. */
const LIST_VALUE_KEYS = new Set(['value', 'otherwise']);
const compareScalars = (a, b) => {
    const x = String(a);
    const y = String(b);
    return x < y ? -1 : x > y ? 1 : 0;
};
/** Множество: без повторов, отсортировано. */
const canonicalSet = (list) => [...new Set(list.map((x) => canonicalize(x)))].sort(compareScalars);
const canonicalize = (v, inWhen = false) => {
    if (v === null || typeof v !== 'object')
        return v;
    if (Array.isArray(v))
        return v.map((x) => canonicalize(x));
    const obj = v;
    const out = {};
    for (const key of Object.keys(obj).sort()) {
        if (ADS_FUNNEL_UNSAFE_KEYS.has(key) || obj[key] === undefined)
            continue;
        const child = obj[key];
        if ((inWhen || LIST_VALUE_KEYS.has(key)) && Array.isArray(child)) {
            out[key] = canonicalSet(child);
        }
        else {
            out[key] = canonicalize(child, key === 'when');
        }
    }
    return out;
};
/** Значение целиком: список — множество; остальное — как `canonicalize`. */
const canonicalTop = (v) => Array.isArray(v) ? canonicalSet(v) : canonicalize(v);
/** Значение в канонической форме (для объектов — новая копия; скаляры — как есть). */
export const canonicalFunnelValue = (v) => canonicalTop(v);
/**
 * Одно и то же значение: скаляры — строго (`Object.is`), списки и правила —
 * по канонической форме (порядок ключей, значений условия и элементов
 * списка, повторы в них — не изменение; порядок правил — изменение).
 */
export const sameFunnelValue = (a, b) => {
    if (Object.is(a, b))
        return true;
    if (a === undefined || b === undefined)
        return false;
    return JSON.stringify(canonicalTop(a)) === JSON.stringify(canonicalTop(b));
};
//# sourceMappingURL=ads-funnel-value.js.map